import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useLocation, useSearch } from 'wouter';
import { getClasses } from '../../services/api';

interface Class {
  id: number;
  name: string;
  day?: string;
  time?: string;
}

interface ClassSelectorProps {
  selectedClassName?: string;
}

const ClassSelector: React.FC<ClassSelectorProps> = ({ selectedClassName }) => {
  const [, setClasses] = useState<Class[]>([]);
  const [uniqueClassNames, setUniqueClassNames] = useState<string[]>([]);
  const [, setLocation] = useLocation();
  const searchParams = useSearch();

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const data = await getClasses();
      setClasses(data);

      // Extract unique class names
      const names = Array.from(new Set(data.map((c) => c.name))).sort();
      setUniqueClassNames(names);
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  const handleClassChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const className = e.target.value;
    if (className) {
      // Preserve existing query parameters
      const queryString = searchParams ? `?${searchParams}` : '';
      setLocation(`/attendance/class/${encodeURIComponent(className)}${queryString}`, { replace: true });
    }
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>Select Class</Form.Label>
      <Form.Select
        value={selectedClassName || ''}
        onChange={handleClassChange}
      >
        <option value="">-- Select a class --</option>
        {uniqueClassNames.map((className) => (
          <option key={className} value={className}>
            {className}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default ClassSelector;
